<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-button type="primary" icon="el-icon-plus" class="handle-del mr10" @click="showEditSource()">渠道</el-button>
                    <el-select v-model="query.type" collapse-tags clearable placeholder="渠道分类" class="handle-select mr10">
                        <el-option label="红丝平台" value="1"></el-option>
                        <el-option label="门店" value="2"></el-option>
                    </el-select>
                    <el-select v-model="query.online" collapse-tags clearable placeholder="线上/线下" class="handle-select mr10">
                        <el-option label="线上" value="1"></el-option>
                        <el-option label="线下" value="2"></el-option>
                    </el-select>
                    <el-select v-model="query.city_id" clearable class="handle-select mr10" placeholder="区域">
                        <el-option v-for="(item, index) in region" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="query.title" placeholder="渠道名称" clearable class="handle-input mr10"></el-input>
                    <el-select v-model="query.is_valid" collapse-tags clearable placeholder="上/下架" class="handle-select mr10">
                        <el-option label="上架" value="1"></el-option>
                        <el-option label="下架" value="0"></el-option>
                    </el-select>
                    <el-button type="primary" icon="el-icon-search" @click="getTableData">搜索</el-button>
                </div>
            </div>
        </div>
        <el-table :data="tableData" ref="multipleTable" highlight-current-row v-loading="loading" :height="tableHeight" :max-height="tableHeight" border>
            <el-table-column prop="id" align="center" label="渠道编号" width="80"></el-table-column>
            <el-table-column align="center" label="渠道分类" width="120">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.type == 1 ? 'primary' : 'danger'">{{ scope.row.type == 1 ? '红丝平台' : '门店' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="线上/线下" align="center" width="120">
                <template slot-scope="scope">
                    <el-tag>{{ scope.row.online == 1 ? '线上' : '线下' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="city" align="center" label="区域" width="120">
                <template slot-scope="scope">
                    <span>{{ dictionary.getRegionItem(scope.row.city_id, '无') }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="title" label="渠道名称">
                <template slot-scope="scope">
                    <el-link v-if="true" icon="el-icon-view" @click="showAccount(scope.row)">{{ scope.row.title }} [{{ scope.row.account }}]</el-link>
                    <span v-else>{{ scope.row.title }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上/下架" align="center" width="120">
                <template slot-scope="scope">
                    <el-tag>{{ scope.row.is_valid == 1 ? '上架' : '下架' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="排序" align="center" width="120" prop="sort">
            </el-table-column>
            <el-table-column label="操作" width="280">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="showEditSource(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="deleteSource(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="footer-box">
            <div class="pagination">
                <el-pagination @size-change="changeLimit" @current-change="changePage" :current-page="pagination.page" :page-size="pagination.limit" :page-sizes="[15, 30, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
            </div>
        </div>

        <!-- 编辑来源 -->
        <edit-source ref="editSource" :parent="_self"></edit-source>
        <!-- 查看账号 -->
        <account ref="account" :parent="_self"></account>
    </div>
</template>

<script>
// import { defineComponent } from '@vue/composition-api'
import dictionary from '@/utils/dictionary.js';
import paginate from '@/utils/paginate.js';
import editSource from './source/edit';
import Account from './account/index';

export default {
    components: {
        editSource,
        Account
    },
    data() {
        let region = dictionary.getRegion();
        return {
            loading: false,
            region: region,
            query: {
                title: '',
                type: '',
                online: '',
                city_id: '',
                is_valid: '',
            },
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            tableHeight: 0,
            tableData: []
        };
    },
    created() {
        // 需要在这里
        this.tableHeight = window.innerHeight - 293;
        // 获取分类列表
        this.getTableData();
    },
    beforeMount() {
        // 先绑定当前this到paginate
        this.dictionary = dictionary;
        paginate.setThis(this);
        Object.assign(this, paginate);
    },
    methods: {
        getTableData() {
            this.loading = true;
            let url = '/api/dictionary.source/index';
            let query = {
                ...this.query
            };
            query['pagination'] = this.pagination;

            this.$post(url, query).then(res => {
                this.tableData = res.data.list;
                this.pagination = res.data.pagination;
                this.loading = false;
            });
        },
        showAccount(row) {
            if (this.$refs['account']) {
                this.$refs['account'].showAccount(row);
            } else {
                this.$nextTick(function () {
                    this.$refs['account'].showAccount(row);
                });
            }
        },
        showEditSource(row) {
            if (this.$refs['editSource']) {
                this.$refs['editSource'].showDialog(row);
            } else {
                this.$nextTick(function () {
                    this.$refs['editSource'].showDialog(row);
                });
            }
        },
        deleteSource(id) {
            this.$confirm('确定删除此来源, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delSourceData(id);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        delSourceData(id) {
            let url = '/api/dictionary.source/delete'
            let query = {
                id: id
            }
            this.$post(url, query).then(res => {
                this.getTableData();
            });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
